import classNames from "classnames";
import { RichText } from "components/RichTextWidget";
import {
  Heading3,
  Heading5,
  Icon,
  PageLink,
  Paragraph,
} from "shared/components";
import { useToggle } from "shared/hooks";

import styles from "./ListView.module.scss";

export const ListView = ({ payload }) => {
  const title = payload?.title ?? "";
  const description = payload?.description ?? "";
  const courses = payload?.courses ?? [];

  const { opened, onToggle } = useToggle();

  return (
    <div className={styles.wrapper}>
      <div
        className={classNames(styles.dropdown, {
          [styles.opened]: opened,
        })}
        onClick={onToggle}
      ></div>
      <div className={styles.top}>
        <Heading3 className={styles.title} color="dark">
          {title}
        </Heading3>
        <Paragraph className={styles.description} color="dark">
          {description}
        </Paragraph>
      </div>
      {opened && (
        <div className={styles.projects}>
          {courses.map((courses) => (
            <PageLink
              key={courses.id}
              link={courses?.course}
              className={styles.link}
            >
              <div className={styles.project}>
                <Heading5 className={styles["project-title"]} color="dark">
                  {courses.title}
                </Heading5>
                <div className={styles["project-description"]}>
                  <RichText
                    value={courses.description}
                    className={styles.description}
                  />
                  <div className={styles.button}>
                    <Icon className={styles.icon} name="large_arrow_right" />
                  </div>
                </div>
              </div>
            </PageLink>
          ))}
        </div>
      )}
    </div>
  );
};
